import { format, formatDistanceToNow, parseISO } from 'date-fns';
import { nb } from 'date-fns/locale';

/**
 * Format date to Norwegian locale
 */
export function formatDate(date: string | Date, formatString: string = 'PPP'): string {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, formatString, { locale: nb });
}

/**
 * Format date and time to Norwegian locale
 */
export function formatDateTime(date: string | Date): string {
  return formatDate(date, 'PPPp');
}

/**
 * Format relative time (e.g., "2 dager siden")
 */
export function formatRelativeTime(date: string | Date): string {
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return formatDistanceToNow(dateObj, { addSuffix: true, locale: nb });
}

/**
 * Format date for display in tables (short format)
 */
export function formatShortDate(date: string | Date): string {
  return formatDate(date, 'dd.MM.yyyy');
}

/**
 * Format date for ISO string (for API calls)
 */
export function toISOString(date: Date): string {
  return date.toISOString();
}
